import TableComponent, {
  IColumnProps,
} from '../../../components/TableComponent';
import { useGetAllLicensesAsync } from '../../../services/LicenseService/hooks/useMutations';
import React, { useEffect, useState } from 'react';
import { ILicenseSimpleProps } from '../../../services/LicenseService/types';
import ButtonComponent from '../../../components/ButtonComponent';
import { Add } from '@mui/icons-material';
import LicenseEditionModal from './LicenseEditionModal';
import ButtonActionsComponent from '../../../components/ButtonActionsComponent';
import { Box } from '@mui/material';

const LicensesList = () => {
  const [licenses, setLicenses] = useState<ILicenseSimpleProps[]>([]);
  const [isVisibleEditionModal, setIsVisibleEditionModal] =
    useState<boolean>(false);
  const { mutateAsync, reset } = useGetAllLicensesAsync();

  const columns: IColumnProps[] = [
    {
      id: 'name',
      label: 'Nome',
      width: '40%',
    },
    {
      id: 'email',
      label: 'Email',
      width: '40%',
    },
    {
      id: 'plans',
      label: 'Planos',
      width: '40%',
      render: (plans: any, rowIndex) => (
        <Box key={rowIndex}>{renderPlans(plans)}</Box>
      ),
    },
    {
      id: 'id',
      label: 'Ações',
      width: 'min',
      render: (id) => (
        <ButtonActionsComponent key={id} isWithDefaultOptionsList />
      ),
    },
  ];

  const renderPlans = (plans: string[]) => {
    if (plans.length > 1) {
      return plans.join(', ');
    }
    return plans;
  };

  useEffect(() => {
    mutateAsync().then(setLicenses);
  }, []);

  return (
    <>
      <TableComponent
        additionalTitleComponent={
          <ButtonComponent
            onClick={() => setIsVisibleEditionModal(true)}
            startIcon={<Add />}
          >
            Nova Licença
          </ButtonComponent>
        }
        title="Licenças cadastradas"
        rows={licenses}
        columns={columns}
      />
      <LicenseEditionModal
        handleSaveForm={() => mutateAsync().then(setLicenses)}
        isOpen={isVisibleEditionModal}
        setIsOpen={setIsVisibleEditionModal}
      />
    </>
  );
};

export default LicensesList;
